import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const TRACKS = {
  'take-my-hand': {
    title: 'Take My Hand',
    spotifyId: '3YBfAgcbJfQPeYJD7EzR7R',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Portada%20Cover%20Take%20My%20Hand%20Header%20Spotify-2.jpg',
  },
  'afternoon-with-myself': {
    title: 'Afternoon with Myself',
    spotifyId: '56aJDJEYj9RTd5RzdCp2tW',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
  'odyssey': {
    title: 'Odyssey',
    spotifyId: '1Le9BmOybAYtPwzmzUpmTP',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
  'its-over': {
    title: 'Its Over',
    spotifyId: '0wI3fdragL3ICjxUBPWQoI',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
  'shades': {
    title: 'Shades',
    spotifyId: '3oJScnk3XI5hQRmzb89klx',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
  'floating-in-time': {
    title: 'Floating in Time',
    spotifyId: '0bEsaNOtREMXFqiPxC7hfE',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
  'floating-in-time-instrumental': {
    title: 'Floating in Time (Instrumental)',
    spotifyId: '6UukZ5s31yU0KNvuJBFnmv',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
  'when-i-wake': {
    title: 'When I Wake',
    spotifyId: '2CyCmaIHAyuna8Yd9iqNiz',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
  'insane': {
    title: 'Insane',
    spotifyId: '4MFRRRaPCUvZduPzqzjOHG',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
  'uplight': {
    title: 'UPLIGHT',
    spotifyId: '2IH7bHyPNBQ6jGF2UT4vPS',
    artwork: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Aft%20Syntetikworld.jpeg',
  },
};

const MESSAGES = {
  es: { redirecting: 'Abriendo Spotify...', button: 'Escuchar en Spotify', fallback: 'Si no se abre automáticamente, haz clic aquí:', explore: 'Explorar más música' },
  en: { redirecting: 'Opening Spotify...', button: 'Listen on Spotify', fallback: "If it doesn't open automatically, click here:", explore: 'Explore more music' },
  pt: { redirecting: 'Abrindo Spotify...', button: 'Ouvir no Spotify', fallback: 'Se não abrir automaticamente, clique aqui:', explore: 'Explorar mais música' },
  fr: { redirecting: 'Ouverture de Spotify...', button: 'Écouter sur Spotify', fallback: "Si Spotify ne s'ouvre pas automatiquement, cliquez ici :", explore: 'Explorer plus de musique' },
  de: { redirecting: 'Spotify wird geöffnet...', button: 'Auf Spotify anhören', fallback: 'Wenn es nicht automatisch öffnet, klicke hier:', explore: 'Mehr Musik entdecken' },
  it: { redirecting: 'Apertura di Spotify...', button: 'Ascolta su Spotify', fallback: 'Se non si apre automaticamente, clicca qui:', explore: 'Esplora più musica' },
};

const SpotifyLanding = () => {
  const { trackSlug } = useParams();
  const [language, setLanguage] = useState('es');
  const [redirecting, setRedirecting] = useState(true);

  const track = TRACKS[trackSlug];

  useEffect(() => {
    if (!track) return;

    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    if (langParam && MESSAGES[langParam]) {
      setLanguage(langParam);
    } else {
      const browserLang = navigator.language.slice(0, 2);
      if (MESSAGES[browserLang]) setLanguage(browserLang);
    }

    const webUrl = `https://open.spotify.com/track/${track.spotifyId}`;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      // Universal Links - Spotify app opens automatically if installed
      window.location.href = webUrl;
    } else {
      setTimeout(() => {
        setRedirecting(false);
        window.open(webUrl, '_blank');
      }, 1500);
    }
  }, [track]);

  if (!track) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <p className="text-white/50">Track not found</p>
      </div>
    );
  }

  const webUrl = `https://open.spotify.com/track/${track.spotifyId}`;
  const t = MESSAGES[language];

  const openSpotify = () => {
    window.location.href = webUrl;
  };

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center relative overflow-hidden" data-testid="spotify-landing">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${track.artwork})`, filter: 'blur(30px) brightness(0.2)', transform: 'scale(1.2)' }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80" />

      <div className="relative z-10 flex flex-col items-center px-6 text-center max-w-md">
        <div className="w-56 h-56 mb-8 rounded-xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.6)] border border-white/10">
          <img src={track.artwork} alt={track.title} className="w-full h-full object-cover" />
        </div>

        <h1 className="text-2xl font-light tracking-wide mb-1">{track.title}</h1>
        <p className="text-white/40 text-sm tracking-[0.2em] mb-8">SYNTETIK</p>

        {redirecting && (
          <div className="mb-6 flex items-center gap-2">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-white/50 text-sm">{t.redirecting}</span>
          </div>
        )}

        <button
          onClick={openSpotify}
          data-testid="spotify-deeplink-button"
          className="flex items-center gap-3 bg-[#1DB954] hover:bg-[#1ed760] text-black font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-[0_4px_20px_rgba(29,185,84,0.3)] mb-4"
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
          </svg>
          {t.button}
        </button>

        {!redirecting && <p className="text-white/30 text-xs mb-8">{t.fallback}</p>}

        <a href="/#music" className="text-white/30 text-xs tracking-[0.15em] hover:text-white/60 transition-colors duration-300 mt-4 border-b border-white/10 pb-1">
          {t.explore}
        </a>

        <p className="text-white/15 text-[10px] tracking-[0.3em] mt-12">SYNTETIK WORLD</p>
      </div>
    </div>
  );
};

export { TRACKS };
export default SpotifyLanding;
